import { EConnectorIdentifier } from '../api/types';

export const CONNECTOR_ID_BAR_WIDTH = 50;
export const CONNECTOR_ID_BAR_THIN_WIDTH = 12;

export function getEffectiveConnectorIdentifier(
    connectorIdentifier?: EConnectorIdentifier
): EConnectorIdentifier {
    return connectorIdentifier ?? EConnectorIdentifier.ALL;
}

export function shouldShowConnectorNumber(
    connectorIdentifier?: EConnectorIdentifier
): boolean {
    return getEffectiveConnectorIdentifier(connectorIdentifier) !== EConnectorIdentifier.SHORT_CODE;
}

export function shouldShowShortCode(connectorIdentifier?: EConnectorIdentifier): boolean {
    const effectiveIdentifier = getEffectiveConnectorIdentifier(connectorIdentifier);
    return (
        effectiveIdentifier === EConnectorIdentifier.SHORT_CODE ||
        effectiveIdentifier === EConnectorIdentifier.ALL
    );
}

export function getConnectorIdBarWidth(connectorIdentifier?: EConnectorIdentifier): number {
    return shouldShowConnectorNumber(connectorIdentifier)
        ? CONNECTOR_ID_BAR_WIDTH
        : CONNECTOR_ID_BAR_THIN_WIDTH;
}

export function getConnectorDisplayLabel({
    connectorNumber,
    shortCode,
    connectorIdentifier,
}: {
    connectorNumber: string;
    shortCode?: string;
    connectorIdentifier?: EConnectorIdentifier;
}): string {
    const effectiveConnectorIdentifier = getEffectiveConnectorIdentifier(connectorIdentifier);

    switch (effectiveConnectorIdentifier) {
        case EConnectorIdentifier.SHORT_CODE:
            return shortCode ?? connectorNumber;
        case EConnectorIdentifier.ALL:
            if (shortCode && connectorNumber) {
                return `${connectorNumber} (${shortCode})`;
            }
            return connectorNumber || shortCode || '';
        case EConnectorIdentifier.CONNECTOR_NUMBER:
        default:
            return connectorNumber;
    }
}
